import React from 'react';
import './InfoPopup.css';

const InfoPopup = ({ open, onClose, title, children }) => {
  if (!open) return null;
  return (
    <div className="info-popup-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="info-popup-modal" onClick={e => e.stopPropagation()}>
        <button className="info-popup-close" onClick={onClose} aria-label="Close info">×</button>
        {title && <h3 className="info-popup-title">{title}</h3>}
        <div className="info-popup-content">{children}</div>
      </div>
    </div>
  );
};

export default InfoPopup;
